import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import "../../cases/addCaseList.scss";
import NearMissesForm from "../components/nearMissesForm";
import Carousel from "../../../library/custom/carouselBox/Carousel";
import CarouselData from "../../../constant/carouselConstant";
import * as incidentAction from "../../../redux/actions/incidentAction";
import * as nearMissesAction from "../../../redux/actions/nearMissesAction";
// import * as caseAction from "../../../redux/actions/caseAction";
import * as userAction from "../../../redux/actions/userAction";
import * as stateCityAction from "../../../redux/actions/stateCityAction";
import Loader from "../../../library/common/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import {
  API_STATUS,
  INCIDENT_REPORT_ADDED,
  INCIDENT_REPORT_UPDATE,
  MODULES_NAME,
} from "../../../constant/constant";
import {
  PERSONAL_INJURY,
  VEHICLE_ACCIDENT,
  UTILITY_DAMAGE,
  STOLEN_PROPERTY,
  NEAR_MISS,
  DASHBOARD,
  ACCESS_DENIED,
  INCIDENT_LIST,
} from "../../../constant/routeContant";
import SuccessScreen from "../../incidents/add-incident/component/successScreen";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { logEvent, validateFileSize } from "../../../utils/helper";
import { fileUpload } from "../../../services/fileUploadService";
import BackBtn from "../../../library/custom/backBtn/backBtn";

export default function NearMissesContainer({ props }) {
  const location = useLocation();
  const existingCaseId = location?.state?.caseId;
  const incidentId = location?.state?.incidentId;
  const editMode = location?.state?.editMode;
  const isDraft = location?.state?.statusId;
  const isDraftforaction = location?.state?.statusId ?? "0";
  const [successScreens, setSuccessScreens] = useState(false);
  let navigate = useNavigate();
  const disptch = useDispatch();
  const incident = useSelector((state) => state.incident.data);
  const status = useSelector((state) => state.addNearMisses.status);
  const addNearMissesData = useSelector((state) => state.addNearMisses.data);
  const caseData = useSelector((state) => state.createdCase.data);
  const nearMissesData = useSelector((state) => state.getNearMissReport.data);
  const isLoading = useSelector((state) => state.users.isLoading);
  const allUsers = useSelector((state) => state.allUsers.data);
  const nearMissesDataStatus = useSelector(
    (state) => state.getNearMissReport?.status,
  );
  const assetOnUserListStatus = useSelector(
    (state) => state.getAssetOnUser.status,
  );

  const assetOnUserList = useSelector((state) => state.getAssetOnUser.data);
  const supervisorOnAssetList = useSelector(
    (state) => state.getSupervisorOnAsset.data,
  );
  const searchAllUsers = (searchType, searchText, projectId = 0) => {
    disptch(
      userAction.searchAllUsers(searchText, searchType, 0, projectId, 1, 0),
    );
  };

  const isAllowed = checkPrivileges([1, 2, 3, 12]);
  const updateNearMissesDataStatus = useSelector(
    (state) => state.updateNearMissesData.status,
  );
  const updateNearMissesData = useSelector(
    (state) => state.updateNearMissesData.data,
  );

  const isSuccess = useSelector(
    (state) =>
      state.incident.status === API_STATUS.SUCCESS &&
      (existingCaseId
        ? existingCaseId
        : state.createdCase.status === API_STATUS.SUCCESS),
  );
  const searchOption = useSelector((state) => state.users.data);

  const showLoader = useSelector(
    (state) =>
      state.addNearMisses.isLoading ||
      state.createdCase.isLoading ||
      state.updateNearMissesData.isLoading ||
      state.incident.isLoading ||
      state.getNearMissReport.isLoading ||
      state.fileUpload.isLoading ||
      state.getAssetOnUser.isLoading ||
      state.getSupervisorOnAsset.isLoading,
  );

  const [dataId, setDataId] = useState("");
  const addAndUpdateNearMisses = async (data) => {
    setDataId(data.nearMisses.incidentId);
    setSuccessScreens(true);
    if (data.nearMisses.incidentId === 0) {
      disptch(nearMissesAction.nearMisses(data.nearMisses));
    } else {
      disptch(nearMissesAction.updateNearMisses(data.nearMisses));
    }
  };

  // const createCase = () => {
  //   const userId = localStorage.getItem("userId");
  //   if (userId) {
  //     let data = {
  //       createdBy: userId,
  //     };
  //     disptch(caseAction.createCase(data));
  //   }
  // };

  const getIncidentData = () => {
    disptch(incidentAction.getIncidentData());
  };

  const [fileError, setFileError] = useState(null);
  const [countError, setCountError] = useState(0);
  const [isLoader, setIsLoader] = useState(false);
  const [fileUploadData, setFileUploadData] = useState();

  const uploadFile = async (data) => {
    const validation = validateFileSize(data);
    if (!validation.isValid) {
      setFileError(validation.errorMessage);
      setCountError(countError + 1);
      return;
    }
    setIsLoader(true);
    fileUpload(data)
      .then((res) => {
        setIsLoader(false);
        const files = { files: res };
        setFileUploadData(files);
      })
      .catch((error) => {
        setCountError(countError + 1);
        setFileError("Error while uploading files.");
      });
  };

  const searchUsers = (searchType, searchText) => {
    disptch(userAction.searchUsers(searchType, searchText));
  };

  const getNearMissedDetails = (caseId, incidentId) => {
    disptch(nearMissesAction.getNearMisses(caseId, incidentId));
  };
  const clearData = () => {
    disptch(userAction.ClearAssetAndUser());
    disptch(userAction.ClearAssetAndSupervisor());
  };
  useEffect(() => {
    clearData();

    if (!isAllowed) {
      navigate(DASHBOARD);
    }
    disptch(nearMissesAction.clearNearMisses());

    if (location.state === "Vehicle Accident") {
      const value = {
        id: 2,
        title: "Vehicle Accident",
      };
      setcarouselValue(value);
    }
    if (existingCaseId && incidentId) {
      getNearMissedDetails(existingCaseId, incidentId);
    }
    // if (!existingCaseId) {
    //   createCase();
    // }
    // searchUsers("", "");
    getIncidentData();
  }, []);

  const [carouselValue, setcarouselValue] = useState({
    id: 5,
    title: "Near Misses",
  });

  const handleOnChangeMethod = (value) => {
    if (!editMode) {
      setcarouselValue(value);
      if (value.id === 1) {
        navigate(PERSONAL_INJURY, {
          state: { caseId: existingCaseId, isDirect: true },
        });
      } else if (value.id === 2) {
        navigate(VEHICLE_ACCIDENT, { state: { caseId: existingCaseId } });
      } else if (value.id === 4) {
        navigate(UTILITY_DAMAGE, { state: { caseId: existingCaseId } });
      } else if (value.id === 3) {
        navigate(STOLEN_PROPERTY, { state: { caseId: existingCaseId } });
      } else if (value.id === 5) {
        navigate(NEAR_MISS, { state: { caseId: existingCaseId } });
      }
    }

    if (value.id === 2) {
      disptch(stateCityAction.getState());
    }
  };
  const successScree = (id) => {
    logEvent("Incident", editMode ? "Update Near Miss" : "Add Near Miss");

    return (
      <SuccessScreen
        id={id}
        caseId={existingCaseId}
        isUpdate={dataId === 0 ? INCIDENT_REPORT_ADDED : INCIDENT_REPORT_UPDATE}
      ></SuccessScreen>
    );
  };

  function getAssetOnUser(params) {
    if (params.userId) {
      const data = {
        assetType: 1,
        userId: params.userId,
      };
      disptch(userAction.getAssetOnUser(data));
    }
  }
  function getSupervisorOnAsset(params) {
    if (params) {
      const data = {
        assetType: 1,
        assetId: params,
      };
      disptch(userAction.getSupervisorOnAsset(data));
    }
  }

  const dataBack = {
    title: "Back",
    route: INCIDENT_LIST,
  };
  return (
    <>
      {editMode && <BackBtn dataBack={dataBack} className="equipmentBack" />}
      {checkPrivileges([1, 2, 12]) ? (
        <>
          <div className="loader-wrapper">
            {(showLoader || isLoader) && <Loader />}
          </div>
          <div>
            {status === API_STATUS.SUCCESS &&
            addNearMissesData &&
            successScreens ? (
              successScree(addNearMissesData?.incidentId)
            ) : updateNearMissesDataStatus === API_STATUS.SUCCESS &&
              updateNearMissesData &&
              successScreens ? (
              successScree(incidentId)
            ) : (
              <div className="dashboard-slider">
                <div>
                  <div className="dashbord_heading">
                    <div className="insi-stitle">
                      <p>Select Incident Type</p>
                      <div className="caseId">
                        Case ID: EVE-{" "}
                        {existingCaseId ? existingCaseId : caseData?.caseId}
                      </div>
                    </div>
                  </div>

                  <Carousel
                    sliderItems={CarouselData}
                    activeSlide={carouselValue}
                    handleOnChange={handleOnChangeMethod}
                    edit={editMode ? true : false}
                  />
                </div>

                <div>
                  {isSuccess && (
                    <NearMissesForm
                      incident={incident}
                      caseId={
                        existingCaseId ? existingCaseId : caseData?.caseId
                      }
                      incidentId={incidentId ? incidentId : 0}
                      caseData={caseData}
                      searchOption={searchOption}
                      searchAllUsers={searchAllUsers}
                      allUsers={allUsers}
                      onSubmit={addAndUpdateNearMisses}
                      nearMissesData={incidentId ? nearMissesData : ""}
                      uploadFile={uploadFile}
                      fileUploadData={fileUploadData}
                      editMode={editMode}
                      searchUsers={searchUsers}
                      isLoading={isLoading}
                      getAssetOnUser={getAssetOnUser}
                      assetOnUserList={assetOnUserList?.jobSite ?? []}
                      assetOnUserData={assetOnUserList}
                      getSupervisorOnAsset={getSupervisorOnAsset}
                      supervisorOnAssetList={
                        supervisorOnAssetList?.result ?? []
                      }
                      fileError={fileError}
                      countError={countError}
                      isDraft={isDraft}
                      isDraftforaction={isDraftforaction}
                      clearData={clearData}
                      nearMissesDataStatus={nearMissesDataStatus}
                      assetOnUserListStatus={assetOnUserListStatus}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
}
